{
  "#LAGERPLATZ_CORE": {
    "COMPONENTS": {
      "ARTIKEL_MENGE_AUSWAHL": {
        "NO_ITEMS": "Auf diesem Lagerplatz sind keine Artikel vorhanden"
      },
      "LAGERPLATZ_SUCHE": {
        "TITLE": "Lagerplatz auswählen",
        "DESCRIPTION": "Bitte tippen um den Lagerplatz aus einer Liste auszuwählen"
      }
    },
    "DIALOGS": {
      "CHOOSE_LAGERPLATZ": "Lagerplatz auswählen",
      "SELECT_UNIT": {
        "TITLE": "Einheit auswählen"
      }
    },
    "MESSAGES": {
      "NO_LAGERPLATZ_FOUND": "Zu diesem Barcode konnten keine Lagerplätze gefunden werden"
    }
  }
}
